'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _actions = require('./actions');

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref) {
  var hasMatched = _ref.user.hasMatched;

  return {
    hasMatched: hasMatched
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    matchMe: function matchMe(shouldOpen) {
      return dispatch((0, _actions.matchMe)(shouldOpen));
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/MatchTooltip/selectors.js
// module id = 1098
// module chunks = 0